import { getText } from '../../utils/functions';
import SimpleButton from '../basicComponents/SimpleButton';


function InformationPopUp({
	translate,
	data,
	onClick,
	colors,
	Icon,

	/* OPTIONAL PROPS */
	classNameDIV = 'pt-9 pb-14 px-16 flex flex-col space-y-12 items-center rounded-sm',
	styleDIV,
	classNameIMG = 'w-20 h-20',
	styleIMG,
	classNameTEXT = 'text-xs md:text-base',
	styleTEXT
}) {
	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: `${colors?.background}`,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleTEXT = {
		color: `${colors?.primary}`
	};
	const defaultStyleIMG = {
		color: `${colors?.primary}`
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDiv = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleTEXT = { ...defaultStyleTEXT, ...styleTEXT };
	const overrideStyleIMG = { ...defaultStyleIMG, ...styleIMG };

	return <div
		id='InformationPopUp'
		className={classNameDIV}
		style={overrideStyleDiv}
	>
		{/* ICON */}
		{Icon
		&& Icon({
			className: classNameIMG,
			style: overrideStyleIMG
		})}
		{/* TEXT */}
		<div
			className={classNameTEXT}
			style={overrideStyleTEXT}
			dangerouslySetInnerHTML={{ __html: getText(data?.information, translate) }}
		/>
		{/* RETURN */}
		<SimpleButton
			colors={colors}
			tag={getText(data?.button, translate)}
			onClick={() => onClick()}
		/>
	</div>;
}

export default InformationPopUp;
